export class PaymentModel {
  public MortgageAccountNumber: number;
  public SubAccountNumber: number;
  public MortgageHolderLastName: string;
  public MortgageHolderDateOfBirth: Date;
  public PropertyPostCode: string;
  public PayeeName: string;
  public PostCode: string;
  public PhoneNumber: string;
  public Amount: number;
  public Source: string;
  public PaymentType: string;
  public PaymentOperationID: number;
  public CaptchaToken: string;

  constructor() {
    this.MortgageHolderDateOfBirth = new Date('01/01/1990 0:00:00 AM UTC');
    this.SubAccountNumber = 0;
  }
}
